var toastEduzz = require('./src/js/toast-eduzz');

module.exports = toastEduzz;